export const scrollTop = (node?: HTMLElement) =>
  (node || window).scrollTo({ top: 0, behavior: 'smooth' })
